import { AppRoutes } from './router';
import { AuthProvider } from './auth/AuthContext';

export function App(): JSX.Element {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
